import { createContext, useContext } from 'react';

interface PromptContextProps {
  dismissible?: boolean;
  dismissPrompt?: () => void;
}
export const PromptContext = createContext<PromptContextProps>({});
PromptContext.displayName = 'Prompt';

export const usePromptContext = () => useContext(PromptContext);
